import React, { useEffect } from "react";
import { useTheme } from "../config/ThemeContext";

function ConfirmationDialog({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  children,
}) {
  const theme = useTheme();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onCancel();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onCancel]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div
        className={`rounded-xl shadow-xl p-6 w-full max-w-sm z-50
        ${theme.primary.lightBg} ${theme.primary.text}`}
      >
        <h2 className="text-lg font-semibold">{title}</h2>
        {message && <p className="text-sm mt-2">{message}</p>}
        {children && <div className="mt-3">{children}</div>}

        <div className="mt-4 flex justify-end space-x-3">
          <button onClick={onConfirm} className={theme.buttons.primary}>
            {confirmText || "Confirm"}
          </button>
          <button onClick={onCancel} className={theme.buttons.secondary}>
            {cancelText || "Cancel"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDialog;
